import { EmployeePosition } from '@/models/EmployeePosition'

export class CouncilMemberParent {
  constructor() {
    this.list = []
  }

  addCouncilMember(item) {
    !this.checkInList(item) && this.list.push(CouncilMember.buildFromAPI(item))
  }

  checkInList(item) {
    return this.list.some(el => el.id === item.id)
  }

  updateCouncilMember(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, CouncilMember.buildFromAPI(item))
  }

  removeCouncilMember(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => CouncilMember.buildFromAPI(el))
    }
    return this
  }
}

export class CouncilMember {
  constructor() {
    this.id = null
    this.position = null
    this.councilName = null
    this.speciality = null
    this.employeePosition = new EmployeePosition()
  }

  getForAPI() {
    return {
      id: this.id,
      position: this.position,
      councilName: this.councilName,
      speciality: this.speciality,
      employeePosition: this.employeePosition.getForAPI()
    }
  }

  static buildFromAPI(obj) {
    const _this = new CouncilMember()
    if (obj) {
      _this.id = obj.id
      _this.position = obj.position
      _this.councilName = obj.councilName
      _this.speciality = obj.speciality
      _this.employeePosition = new EmployeePosition(obj.employeePosition)
    }
    return _this
  }
}
